import { BaseAPI } from "@utils/base-api";

export interface ISessionStartRequest {
  accessToken: string;
  refreshToken: string;
  kkCustomerId?: string;
  accessTokenMaxAge: number;
  kkCustomerIdMaxAge: number;
  rememberMe: boolean;
}

export interface ISessionStartResponse {
  success: boolean;
}

export interface ISessionEndResponse {
  success: boolean;
}

export interface ISessionRefreshResponse {
  status: "success";
  message: string;
  accessToken: string;
  expiresIn: number;
}

export interface ISessionImpersonateResponse {
  success: boolean;
}

export class AuthProviderAPI extends BaseAPI {

  constructor(baseURL: string) {
    super(baseURL, undefined, { withCredentials: true });
  }

  /**
   * Start a new session by setting cookies on the server
   */
  async startSession(request: ISessionStartRequest): Promise<ISessionStartResponse> {
    const response = await this.axios.post<ISessionStartResponse>("/api/auth/session/start", request);
    return response.data;
  }

  /**
   * End the current session by clearing cookies on the server
   */
  async endSession(): Promise<ISessionEndResponse> {
    const response = await this.axios.post<ISessionEndResponse>("/api/auth/session/end");
    return response.data;
  }

  /**
   * Refresh the current session
   */
  async refreshSession(): Promise<ISessionRefreshResponse> {
    const response = await this.axios.post<ISessionRefreshResponse>("/api/auth/session/refresh");
    return response.data;
  }

  /**
   * Impersonate user in the current session
   */
  async impersonateSession(accessToken: string): Promise<ISessionImpersonateResponse> {
    const response = await this.axios.post<ISessionImpersonateResponse>("/api/auth/session/impersonate", {
      accessToken,
    });
    return response.data;
  }

}
